const STORAGE_KEY = "data_store";

export const saveState = (state) => {
  try {
    const serialized = JSON.stringify(state);
    localStorage.setItem(STORAGE_KEY, serialized);
  } catch (e) {
    console.error("Failed to save state", e);
  }
};

export const loadState = () => {
  try {
    const serialized = localStorage.getItem(STORAGE_KEY);
    if (!serialized) return undefined;
    return JSON.parse(serialized);
  } catch (e) {
    console.error("Failed to load state", e);
    return undefined;
  }
};

export const clearState = () => {
  localStorage.removeItem(STORAGE_KEY);
};
